// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1563":"d6340518","2313":"6322452c"}[chunkId] + ".chunk.css";
};